import { presenceActionTypes } from "./reducer";

import { API } from '../../../helper/api';

export function getEvents(order = "ASC") {
    return (dispatch) => {
        dispatch({
        type: presenceActionTypes.PRESENCE_GET_EVENTS_BEGIN,
        });

        return API.get('event/list/' + order, { categories: 'False', images: 'True', moderators: 'True', obsolete: 'False' }).then(
        (res) => {
            const data = res.data;

            dispatch({
            type: presenceActionTypes.PRESENCE_GET_EVENTS_SUCCESS,
            data: data,
            });

            return res;
        }).catch(
            (err) => {
            dispatch({
                type: presenceActionTypes.PRESENCE_GET_EVENTS_FAILURE,
                data: { error: err },
            });

            return Promise.reject(err);
            },
        );
    }
}

export function getEvent(id) {
    return (dispatch) => {
        dispatch({
        type: presenceActionTypes.PRESENCE_GET_EVENT_BEGIN,
        });
        
        return API.get('Booking/users_status/' + id).then(
        (res) => {
            const data = res.data;

            dispatch({
            type: presenceActionTypes.PRESENCE_GET_EVENT_SUCCESS,
            data: data,
            });

            return res;
        }).catch(
            (err) => {
            dispatch({
                type: presenceActionTypes.PRESENCE_GET_EVENT_FAILURE,
                data: { error: err },
            });

            return Promise.reject(err);
            },
        );
    }
}

export function markLocalPresence(userId, present) {
    return {
        type: presenceActionTypes.PRESENCE_MARK_LOCAL_PRESENT,
        userId,
        present,
    }
}

export function addLocalUser(user, eventId) {
    return {
        type: presenceActionTypes.PRESENCE_ADD_LOCAL_USER,
        user,
        eventId,
    }
}



// WEBPACK FOOTER //
// ./src/features/presence/redux/actions.js